/*
 * jQuery Cascade menu plugin
 *
 * @description
 *  Horizontally sliding hierarchical menu
 *
 * @requires jQuery, jQuery.actual
 *
 * @arguments
 *    @options (object) optional
 *      animationDuration:        250,
 *      menuSelector:             'ul',
 *      expandSelector:           'li.expand',
 *      activeSelector:           '.active'
 */
;(function ($, window, document, undefined) {
  $.cascadeMenu = function (el, options) {

    var that = this;

    that.el = el;
    that.$el = $(el);
    that.$list = that.$el.find('ul').first();

    that.queue = [];

    that.getActiveItem = function () {
      var $activeItem = null,
          $activeItems = that.$el.find(that.options.activeSelector);

      if (!$activeItems.length) {
        return null;
      }

      $activeItems.each(function (index, element) {
        var $link = $(element).find('a').first();
        if ($link.attr('href') === window.location.pathname) {
          $activeItem = $(element);
          return true;
        }
      });

      return $activeItem;
    };

    that.moveForward = function ($target) {
      if (that.$el.actual('outerHeight') < $target.actual('outerHeight')) {
        that.$list.css('height', $target.actual('outerHeight'));
      }

      $target.show();

      that.$list.animate({ left: '-=100%' }, {
        duration: that.options.animationDuration,
        complete: function () {
          that.$list.css('height', $target.actual('outerHeight'));
        }
      });
      that.queue.push($target);
    };

    that.moveBack = function ($target) {
      if (that.$el.actual('outerHeight') < $target.actual('outerHeight')) {
        that.$list.css('height', $target.actual('outerHeight'));
      }

      var $previousTarget = that.queue.pop();

      that.$list.animate({ left: '+=100%' }, {
        duration: that.options.animationDuration,
        complete: function () {
          $previousTarget.hide();
          if (that.queue.length) {
            that.$list.css('height', $target.actual('outerHeight'));
          } else {
            that.$list.css('height', 'auto');
          }
        },
      });
    };

    that.moveToActive = function () {
      var $activeItem, $parents, $parent, depth, percentage;

      $activeItem = that.getActiveItem();
      if (!$activeItem) {
        return;
      }
      $parents = $activeItem.parents(that.options.activeSelector);
      if (!$parents.length) {
        return;
      }
      $parent = $activeItem.closest('ul');
      $parent.show();

      // Open all parent menus
      $parents.each(function (index, element) {
        $(element).addClass('open');
        $(element).closest('ul').show();
        if (index < $parents.length - 1) {
          that.queue.push($(element).closest('ul'));
        }
      });

      that.queue.push($parent);

      // Scroll to desired depth
      depth = $parents.length;
      percentage = (100 * depth) + '%';
      that.$list.animate({ left: '-=' + percentage }, {
        duration: 0,
        complete: function () {
          var height = $parent.actual('outerHeight');
          if (height > 0) {
            that.$list.css('height', height);
          }
        }
      });
    };

    that.actionDispatcher = function (eventObject) {
      eventObject = eventObject || window.event || {};
      eventObject.preventDefault();

      var $link = $(eventObject.currentTarget);
      var $parent, $target;
      if ($link.hasClass('forward')) {
        $target = $link.closest(that.options.expandSelector).find(that.options.menuSelector).first();
        that.moveForward($target);
        $parent = $link.closest(that.options.menuSelector);
        // Show previous state collapsed menu item
        if ($parent.hasClass('open')) {
          $parent.prev('a').hide();
        }
      } else if ($link.hasClass('back')) {
        $target = $link.closest(that.options.expandSelector).closest(that.options.menuSelector);
        // Switch scroll target to parent element,
        // if the previous state was a collapsed menu
        if ($target.hasClass('open')) {
          $parent = $target.parents(that.options.menuSelector);
          $target = $parent;
        }
        that.moveBack($target);
        if ($parent) {
          $parent.find('a').show();
        }
      }
    };

    that.init = function () {
      // Extend options.
      that.options = $.extend($.cascadeMenu.defaults, options);

      // Event bindings.
      // Action links.
      $('.action', that.$el).on('click', that.actionDispatcher);
    };

    // Trigger initialization.
    that.init();
    that.moveToActive();
  };

  // Default options for Cascade menu.
  $.cascadeMenu.defaults = {
    animationDuration: 250,
    menuSelector: 'ul',
    expandSelector: 'li.expand',
    activeSelector: '.active'
  };

  // Plugin wrapper.
  $.fn.cascadeMenu = function (options) {
    return this.each(function () {
      (new $.cascadeMenu(this, options));
    });
  };

})(jQuery, window, document);
